<header>
    <div class="btn_header" id="header_btn">
        <div class="header_logo" id="headerLogo" routerLink=""></div>
        <button class="navbar-toggler" id="trigger-overlay" type="button" data-bs-toggle="collapse"
            data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false"
            aria-label="Toggle navigation">
            <div class="menu_icon"></div>
        </button>
    </div>
    <div class="">
        <nav class="navbar navbar-expand-lg bg-body-tertiary navbar1" id="mobNav">
            <a href="" class="a_kidzee_logo">
                <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/Kidzee_Logo.svg" width="15%" class="kidzee_logo_img" alt="">
            </a>
            <div class="collapse navbar-collapse nav_body" id="navbarNavDropdown">
                <ul class="navbar-nav ul_content">
                    <li class="nav-item">
                        <a class="nav-link active menu1" aria-current="page"
                            (click)="scrollToDiv('home_div');gotPage()">Home</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link active menu1" aria-current="page"
                            (click)="scrollToDiv('about_div');gotPage()">About Us</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link active menu1" aria-current="page"
                            (click)="scrollToDiv('whyKidzee_div');gotPage()"> Why Kidzee?</a>
                    </li>

                    <li class="nav-item">
                        <a class="nav-link active menu1" aria-current="page"
                            (click)="scrollToDiv('fAQs_div');gotPage()">FAQs</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link active menu5" aria-current="page"
                            (click)="scrollToDiv('testimonials_div');gotPage()">Testimonials</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link active menu" aria-current="page"
                            (click)="scrollToDiv('contactUs_div');gotPage()">Contact Us</a>
                    </li>

                </ul>
            </div>
        </nav>
    </div>
    <div class="whiteHeader" id="whiteHeader">
        <nav class="nav navbar navbar-expand-lg">
            <div class="container-fluid">
                <div class="navbar-brand">
                </div>
                <div class="menu_icon" data-bs-toggle="collapse" data-bs-target="#navbarNav"></div>
                <div class="collapse navbar-collapse " id="navbarNav">
                    <a href="" class="a_kidzee_logo">
                        <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/Kidzee_Logo.svg" width="15%" class="kidzee_logo_img"
                            alt="">
                    </a>
                    <ul class="navbar-nav ul_content">
                        <li class="nav-item">
                            <a class="nav-link active menu1" aria-current="page"
                                (click)="scrollToDiv('home_div')">Home</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link active menu1" aria-current="page" (click)="scrollToDiv('about_div')">
                                About Us</a>
                        </li>

                        <li class="nav-item">
                            <a class="nav-link active menu1" aria-current="page" (click)="scrollToDiv('whyKidzee_div')">
                                Why Kidzee?</a>
                        </li>

                        <li class="nav-item">
                            <a class="nav-link active menu1" aria-current="page"
                                (click)="scrollToDiv('fAQs_div')">FAQs</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link active menu5" aria-current="page"
                                (click)="scrollToDiv('testimonials_div')">Testimonials</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link active menu" aria-current="page"
                                (click)="scrollToDiv('contactUs_div')">Contact Us</a>
                        </li>

                    </ul>
                </div>
            </div>
        </nav>

    </div>
</header>

<section>

    <div class="mainDiv">
        <div class="banner_content_slider_desk" id="home_div">
            <div id="carouselExampleControls" class="carousel slide">
                <div class="carousel-inner">
                    <div class="carousel-item active">
                        <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/newadmissionkidzee_banner_desktop.png"
                            class="d-none d-lg-block img-fluid slider_banner" alt="banne">
                    </div>
                </div>
            </div>

        </div>
        <div class="subMenu_content">
            <app-sub-menu></app-sub-menu>
        </div>

        <div class="admissionForm">
            <div class="row">
                <div class="col-md-6">
                    <!-- <div class="desk_res">
                        <div class="count_box">
                            <div class="count">
                                <div class="num_box">1</div>
                                <div class="count_para">
                                    Fill out the admission enquiry form.
                                </div>
                            </div>
                            <div class="count">
                                <div class="num_box">2</div>
                                <div class="count_para">
                                    Get invited to the nearest Kidzee pre-school.
                                </div>
                            </div>
                            <div class="count">
                                <div class="num_box">3</div>
                                <div class="count_para">
                                    Visit the Kidzee centre and explore more.
                                </div>
                            </div>
                            <div class="count">
                                <div class="num_box">4</div>
                                <div class="count_para">
                                    Submit your documents.
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <div class="mob_res">
                        <div class="count_box_mob ">
                            <div id="carouselExampleIndicators" class="carousel slide">
                                <div class="carousel-inner">
                                    <div class="carousel-item">
                                        <div class="count">
                                            <div class="num_box">1</div>
                                            <div class="count_para">
                                                Fill the School Admission Inquiry
                                                Form on the Website
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="count">
                                            <div class="num_box">2</div>
                                            <div class="count_para">
                                                We will invite you to the nearest Kidzee preschool
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="count">
                                            <div class="num_box">3</div>
                                            <div class="count_para">
                                                Visit the School for Campus Tour
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="count">
                                            <div class="num_box">4</div>
                                            <div class="count_para">
                                                Join the Kidzee Family
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="col-md-6">
                    <form [formGroup]="admissionForm">
                        <div class="form_content">
                            <div class="h1">Admissions Open For AY 2025–26</div>
                            <div class="form-group mt-2">
                                <input type="text" class="form-control" placeholder="First Name*"
                                    formControlName="fname" [ngClass]="{ 'is-invalid': submitted && f.fname.errors }" />
                                <div *ngIf="submitted && f.fname.errors" class="invalid-feedback">
                                    <span class="text-danger msg_txt"
                                        *ngIf="(f.fname.touched || submitted) && f.fname.errors?.required">
                                        First Name is required
                                    </span>
                                </div>
                            </div>
                            <div class="form-group mt-2">
                                <input type="text" class="form-control" placeholder="Last Name*" formControlName="lname"
                                    [ngClass]="{ 'is-invalid': submitted && f.lname.errors }" />
                                <div *ngIf="submitted && f.lname.errors" class="invalid-feedback">
                                    <span class="text-danger msg_txt"
                                        *ngIf="(f.lname.touched || submitted) && f.lname.errors?.required">
                                        Last name is required
                                    </span>
                                </div>
                            </div>
                            <div class="form-group mt-2">
                                <input type="text" class="form-control" placeholder="Email*" formControlName="email"
                                    [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
                                <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                                    <span class="text-danger msg_txt"
                                        *ngIf="(f.email.touched || submitted) && f.email.errors?.required">
                                        Email is required
                                    </span>
                                    <span class="text-danger msg_txt" *ngIf="f.email.touched && f.email.errors?.email">
                                        Enter a valid email address
                                    </span>
                                </div>
                            </div>
                            <div class="form-group mt-2">
                                <input type="text" class="form-control" placeholder="Mobile*" (keyup)="getMobileNO();"
                                    formControlName="mobile" [ngClass]="{ 'is-invalid': submitted && f.mobile.errors }">
                                <div *ngIf="submitted && f.mobile.errors" class="invalid-feedback">
                                    <span *ngIf="f.mobile.errors?.required">Mobile is required.</span>
                                    <span *ngIf="f.mobile.errors?.pattern">Please, Enter 10 digit Mobile.</span>

                                </div>
                                <div *ngIf="otpInput" class="validMsg">OTP sent successfully</div>
                            </div>
                            <div class="form-group mt-1" *ngIf="otpInput">
                                <input type="text" class="form-control" placeholder="Enter OTP*" (keyup)="verifyOTP();"
                                    formControlName="otp" [ngClass]="{ 'is-invalid': submitted && f.otp.errors }">
                                <div *ngIf="submitted && f.otp.errors" class="invalid-feedback">
                                    <span *ngIf="f.otp.errors?.required">OTP is required.</span>
                                </div>
                                <div *ngIf="otp_ValidMsg" class="validMsg">OTP verified successfully</div>
                                <div *ngIf="otp_inValidMsg" class="inValidMsg">please enter valid otp</div>
                            </div>

                            <div class="form-group mt-2">
                                <input type="text" class="form-control" placeholder="Pin Code*"
                                    [(ngModel)]="selectedpincode" formControlName="pinCode"
                                    [ngClass]="{ 'is-invalid': submitted && f.pinCode.errors }">
                                <div *ngIf="submitted && f.pinCode.errors" class="invalid-feedback">
                                    <span *ngIf="f.pinCode.errors?.required">Pin code is required.</span>
                                    <span *ngIf="f.pinCode.errors?.pattern">Please, Enter 6 digit pincode.</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group mt-2">
                                        <select name="" id="" class="form-control" #ddlcountry
                                            [(ngModel)]="selectedcountry" formControlName="country"
                                            (change)="selectCountry(ddlcountry.value)"
                                            [ngClass]="{ 'is-invalid': submitted && f.country.errors }">
                                            <option value="">Country*</option>
                                            <option value="{{country.Country_Name}}"
                                                *ngFor="let country of countryList">{{country.Country_Name}}</option>
                                        </select>
                                        <div *ngIf="submitted && f.country.errors" class="invalid-feedback">
                                            <span class="text-danger msg_txt"
                                                *ngIf="(f.country.touched || submitted) && f.country.errors?.required">
                                                Country is required
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group mt-2">
                                        <select name="" id="" class="form-control" [(ngModel)]="selectedstate"
                                            formControlName="state" (change)="selectState($event)"
                                            [ngClass]="{ 'is-invalid': submitted && f.state.errors }">
                                            <option value="">State/District*</option>
                                            <option value="{{state.State_Name}}" *ngFor="let state of stateList">
                                                {{state.State_Name}}</option>
                                        </select>
                                        <div *ngIf="submitted && f.state.errors" class="invalid-feedback">
                                            <span class="text-danger msg_txt"
                                                *ngIf="(f.state.touched || submitted) && f.state.errors?.required">
                                                State/District is required
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group mt-2">
                                        <select name="" id="" class="form-control" [(ngModel)]="selectedCity"
                                            formControlName="city" (change)="selectCity($event)"
                                            [ngClass]="{ 'is-invalid': submitted && f.city.errors }">
                                            <option value="">City*</option>
                                            <option value="{{city.City_Name}}" *ngFor="let city of cityList">
                                                {{city.City_Name}}</option>
                                        </select>
                                        <div *ngIf="submitted && f.city.errors" class="invalid-feedback">
                                            <span class="text-danger msg_txt"
                                                *ngIf="(f.city.touched || submitted) && f.city.errors?.required">
                                                City is required
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group mt-2">
                                        <select name="" id="" class="form-control" [(ngModel)]="selectedDevice"
                                            formControlName="location" (change)="selectCentet(selectedDevice)"
                                            [ngClass]="{ 'is-invalid': submitted && f.location.errors }">
                                            <option value="">Location*</option>
                                            <option value="{{franchise.Franchisee_Code}}"
                                                *ngFor="let franchise of franchiseeList">{{franchise.Franchisee_Name}}
                                            </option>
                                        </select>
                                        <div *ngIf="submitted && f.location.errors" class="invalid-feedback">
                                            <span class="text-danger msg_txt"
                                                *ngIf="(f.location.touched || submitted) && f.location.errors?.required">
                                                Location is required
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div class="form-group mt-2">
                                <label for="" class="lebel_text">Enter the text as displayed</label>
                                <div class="box">
                                    <div class="box-CAPTCHA" id="box-CAPTCHA">
                                        <div class="CAPTCHA" id="CAPTCHA">{{gen_captcha}}</div>
                                        <!-- <div *ngFor="let captcha of captchaText">
                                            <b>{{captcha}}</b>
                                        </div> -->
                                        <div class="captcha_content_flex">
                                            <input type="text" id="input" placeholder="Type CAPTCHA Here" maxlength="6">

                                            <div id="wrong" style="margin-left: 10px;color: #f00;"></div>
                                            <div id="done" style="margin-left: 10px;color: #080;"></div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                            <div class="form-group mt-0 d-flex justify-content-center">
                                <!-- <div class="submit_btn text-center" id="submit_form" (click)="validationForm()" >Submit</div> -->
                                <div class="submit_btn text-center" id="submit" (click)="validationForm()">Submit</div>
                            </div>
                        </div>
                    </form>
                    <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
                </div>
<div class="desk_res">
                        <div class="count_box">
                            <div class="count">
                                <div class="num_box">1</div>
                                <div class="count_para">
                                    Fill out the admission enquiry form.
                                </div>
                            </div>
                            <div class="count">
                                <div class="num_box">2</div>
                                <div class="count_para">
                                    Get invited to the nearest Kidzee pre-school.
                                </div>
                            </div>
                            <div class="count">
                                <div class="num_box">3</div>
                                <div class="count_para">
                                    Visit the Kidzee centre and explore more.
                                </div>
                            </div>
                            <div class="count">
                                <div class="num_box">4</div>
                                <div class="count_para">
                                    Submit your documents.
                                </div>
                            </div>
                        </div>
                    </div>
                
                <div class="banner_content_slider_mob">
                    <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/newadmissionkidzee_banner_mobile.png" width="100%"
                        alt="">
                </div>

                <div class="mob_res">
                    <div class="count_box_mob ">
                        <div class="row">
                            <div class="col-6">
                                <div class="count">
                                    <div class="num_box">1</div>
                                    <div class="count_para">
                                        Fill out the admission enquiry form.
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="count">
                                    <div class="num_box">2</div>
                                    <div class="count_para">
                                        Get invited to the nearest Kidzee pre-school.
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 mt-3">
                                <div class="count">
                                    <div class="num_box">3</div>
                                    <div class="count_para">
                                        Visit the Kidzee centre and explore more.
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 mt-3">
                                <div class="count">
                                    <div class="num_box">4</div>
                                    <div class="count_para">
                                        Submit your documents.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/chocolate_img.png" class="chocolate_img_content" alt="">
      <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/bag_img.png" class="bag_img_content" alt="">
      <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/btrfly_img.png" class="btrfly_img_content" alt=""> -->
        <!-- <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/mouse_img.png" class="mouse_img_content" alt=""> -->
        <div id="about_div">
            <div class="aboutUs_content">
                <div class="aboutUs">
                    <div class="sub_content">
                        <div class="row flex-column-reverse flex-lg-row">
                            <div class="col-md-6">
                                <!-- <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/scale.png" class="scale_img" alt="">
                    <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/bag_img.png" class="bag_img_content" alt=""> -->
                                <div class="monkeyContent">
                                    <img srcset="https://cdn.zeelearn.com/pmcontent/kidzee/aboutus.png"
                                        loading="lazy" alt="" class="monkey1">
                                    <!-- <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/mouse_img.png" class="mouse_img_content" alt=""> -->
                                </div>
                                <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/pen.png" class="pen_img_content" alt="">
                            </div>
                            <div class="col-md-6">
                                <div class="text_content">
                                    <div class="right_content1">
                                        <h1 class="title">
                                            About Us<br>
                                            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/bottom_img.png"
                                                class="bottom_img_content" alt="">
                                        </h1>
                                        <div class="subTitle mt-2">
                                            Kidzee Preschool
                                        </div>

                                        <div class="paragraph_content mt-2">
                                            <p>Kidzee Pre-school is a leading pre-school chain in India and Nepal,
                                                backed by Zee Learn Ltd. With more than two decades of experience in the
                                                pre-school industry, Kidzee has nurtured more than 1.4 million children
                                                throughout India. Being one of the largest pre-schools in India, Kidzee
                                                has 2,000+ centres in 750+ cities.</p>
                                            <p>Kidzee is a leader and a trendsetter in Early Childhood Care and
                                                Education (ECCE). It follows the Péntemind pedagogy, which nurtures
                                                holistic development through five essential learning minds: the
                                                Empathetic Mind, Conscientious Mind, Focused Mind, Analytical Mind, and
                                                Inventive Mind.</p>
                                            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/fruit_img.png"
                                                class="fruit_img_content" alt="">
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="numb_list_mob counter_mobile">
                <div id="carouselExampleIndicatorsCT" class="carousel slide">
                    <div class="carousel-indicators">
                        <button type="button" data-bs-target="#carouselExampleIndicatorsCT" data-bs-slide-to="0"
                            class="active" aria-current="true" aria-label="Slide 1"></button>
                        <button type="button" data-bs-target="#carouselExampleIndicatorsCT" data-bs-slide-to="1"
                            aria-label="Slide 2"></button>
                        <button type="button" data-bs-target="#carouselExampleIndicatorsCT" data-bs-slide-to="2"
                            aria-label="Slide 3"></button>
                        <button type="button" data-bs-target="#carouselExampleIndicatorsCT" data-bs-slide-to="3"
                            aria-label="Slide 4"></button>
                    </div>
                    <div class="carousel-inner">
                        <div class="carousel-item active">
                            <div class="box">
                                <div class="count_num1">
                                    <div class="num_count">20</div>
                                    <div class="label">Years Of Excellence</div>
                                </div>
                                <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/counter_bg1.png" width="80%" alt="">
                            </div>
                        </div>
                        <div class="carousel-item">
                            <div class="box">
                                <div class="count_num2">
                                    <div class="num_count">2300+</div>
                                    <div class="label">Preschools</div>
                                </div>
                                <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/counter_bg2.png" width="80%" alt="">
                            </div>
                        </div>
                        <div class="carousel-item">
                            <div class="col-md-3">
                                <div class="box">
                                    <div class="count_num3">
                                        <div class="num_count">750+</div>
                                        <div class="label">Cities</div>
                                    </div>
                                    <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/counter_bg3.png" width="80%" alt="">
                                </div>
                            </div>
                        </div>
                        <div class="carousel-item">
                            <div class="box">
                                <div class="count_num">
                                    <div class="num_count">14Lac+</div>
                                    <div class="label"> Children’s Nurtured</div>
                                </div>
                                <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/counter_bg4.png" width="80%" alt="">
                            </div>
                        </div>
                    </div>
                    <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicatorsCT"
                        data-bs-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Previous</span>
                    </button>
                    <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicatorsCT"
                        data-bs-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Next</span>
                    </button>
                </div>
            </div>
        </div>
        <div class="count_content">
            <div class="row">
                <div class="col-md-3">
                    <div class="box">
                        <div class="count_num1">
                            <div class="num_count">20</div>
                            <div class="label">Years Of Excellence</div>
                        </div>
                        <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/counter_bg1.png" width="80%" alt="">
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="box">
                        <div class="count_num2">
                            <div class="num_count">2300+</div>
                            <div class="label">Preschools</div>
                        </div>
                        <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/counter_bg2.png" width="80%" alt="">
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="box">
                        <div class="count_num3">
                            <div class="num_count">750+</div>
                            <div class="label">Cities</div>
                        </div>
                        <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/counter_bg3.png" width="80%" alt="">
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="box">
                        <div class="count_num">
                            <div class="num_count">14Lac+</div>
                            <div class="label">Children’s Nurtured</div>
                        </div>
                        <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/counter_bg4.png" width="80%" alt="">
                    </div>
                </div>
            </div>
        </div>

        <div class="kidzeeSchool_content mt-2" id="whyKidzee_div">
            <div class="preSchoolbgImg_content">
                <div class="sub_content">
                    <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/blue_home.png" class="home_img_content" alt="">
                    <h1 class="title text-center">
                        <span class=""> Why Choose Kidzee Preschool?</span>

                    </h1>
                    <div class="content">
                        <p class="text-center">Kidzee Preschool is your experienced trusted partner in providing
                            exceptional early
                            education for your child. Here's why Kidzee stands out as the preferred choice for parents
                            seeking the
                            best for their little ones</p>
                    </div>
                    <div id="carouselExampleIndicators" class="carousel slide">
                        <div class="carousel-indicators">
                        </div>
                        <div class="carousel-inner">
                            <div class="carousel-item active">
                                <div class="img_list mt-5">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <div class="main_box">
                                                <div class="img_box">
                                                    <img src="https://cdn.zeelearn.com/pmcontent/kidzee/holistic.png"
                                                        width="100%" alt="">
                                                </div>
                                                <div class="info_content">
                                                    <div class="img_sub_title">
                                                        Holistic Learning
                                                    </div>
                                                    <div>
                                                        <p class="text-center">Fostering all-round development through a
                                                            balanced blend of academics, play, and life skills.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="main_box">
                                                <div class="img_box">
                                                    <img src="https://cdn.zeelearn.com/pmcontent/kidzee/circle_child.png"
                                                        width="100%" alt="">
                                                </div>
                                                <div class="info_content">
                                                    <div class="img_sub_title">
                                                        Expert Educators
                                                    </div>
                                                    <div>
                                                        <p class="text-center">Skilled teachers dedicated to nurturing
                                                            every child’s unique potential.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="main_box">
                                                <div class="img_box">
                                                    <img src="https://cdn.zeelearn.com/pmcontent/kidzee/safe.png"
                                                        width="100%" alt="">
                                                </div>
                                                <div class="info_content">
                                                    <div class="img_sub_title">
                                                        Safe and Secure
                                                    </div>
                                                    <div>
                                                        <p class="text-center">A protected, child-friendly environment
                                                            ensuring safety and peace of mind.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="main_box">
                                                <div class="img_box">
                                                    <img src="https://cdn.zeelearn.com/pmcontent/kidzee/boy.png"
                                                        width="100%" alt="">
                                                </div>
                                                <div class="info_content">
                                                    <div class="img_sub_title">
                                                        Innovative Learning
                                                    </div>
                                                    <div>
                                                        <p class="text-center">Engaging, modern teaching methods that
                                                            make learning fun and impactful.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <!-- <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators"
                            data-bs-slide="prev">
                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span class="visually-hidden">Previous</span>
                        </button>
                        <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators"
                            data-bs-slide="next">
                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                            <span class="visually-hidden">Next</span>
                        </button> -->
                    </div>
                    <!-- <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/mouse_img.png" class="mouse_img_content" alt=""> -->
                </div>
            </div>

            <div class="mobileView">
                <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/blue_home.png" class="home_img_content" alt="">
                <h1 class="title text-center">
                    <span class=""> Why Choose<br> Kidzee Preschool? </span>

                </h1>
                <div class="content">
                    <p class="text-center">Kidzee Preschool is your experienced trusted partner in providing exceptional
                        early
                        education for your child. Here's why Kidzee stands out as the preferred choice for parents
                        seeking the
                        best for their little ones</p>
                </div>
                <div id="carouselExampleDark1" class="carousel carousel-dark slide">
                    <div class="carousel-indicators">
                        <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="0" class="active"
                            aria-current="true" aria-label="Slide 1"></button>
                        <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="1"
                            aria-label="Slide 2"></button>
                        <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="2"
                            aria-label="Slide 3"></button>
                        <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="3"
                            aria-label="Slide 4"></button>
                    </div>
                    <div class="carousel-inner">
                        <div class="carousel-item active" data-bs-interval="10000">
                            <div class="main_box">
                                <div class="img_box">
                                    <img src="https://cdn.zeelearn.com/pmcontent/kidzee/holistic.png"
                                        width="100%" alt="">
                                </div>
                                <div class="info_content">
                                    <div class="img_sub_title">
                                        Holistic Learning
                                    </div>
                                    <div>
                                        <p class="text-center">Fostering all-round development through a balanced blend
                                            of academics, play, and life skills.</p>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="carousel-item" data-bs-interval="3000">
                            <div class="main_box">
                                <div class="img_box">
                                    <img src="https://cdn.zeelearn.com/pmcontent/kidzee/circle_child.png"
                                        width="100%" alt="">
                                </div>
                                <div class="info_content">
                                    <div class="img_sub_title">
                                        Expert Educators
                                    </div>
                                    <div>
                                        <p class="text-center">Skilled teachers dedicated to nurturing every child’s
                                            unique potential.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="carousel-item" data-bs-interval="2000">
                            <div class="main_box">
                                <div class="img_box">
                                    <img src="https://cdn.zeelearn.com/pmcontent/kidzee/safe.png"
                                        width="100%" alt="">
                                </div>
                                <div class="info_content">
                                    <div class="img_sub_title">
                                        Safe and Secure
                                    </div>
                                    <div>
                                        <p class="text-center">A protected, child-friendly environment ensuring safety
                                            and peace of mind.</p>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="carousel-item">
                            <div class="main_box">
                                <div class="img_box">
                                    <img src="https://cdn.zeelearn.com/pmcontent/kidzee/boy.png"
                                        width="100%" alt="">
                                </div>
                                <div class="info_content">
                                    <div class="img_sub_title">
                                        Innovative Learning
                                    </div>
                                    <div>
                                        <p class="text-center">Engaging, modern teaching methods that make learning fun
                                            and impactful.</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleDark1"
                            data-bs-slide="prev">
                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span class="visually-hidden">Previous</span>
                        </button>
                        <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleDark1"
                            data-bs-slide="next">
                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                            <span class="visually-hidden">Next</span>
                        </button>
                    </div>


                </div>

            </div>
        </div>
        <div class="faq_content" id="fAQs_div">
            <div class="desktopList">
                <div class="faq_content">
                    <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/dall_girl.png" class="dall_girl_content" alt="">
                    <div class="sub_faq_content">
                        <h1 class="title text-center">
                            FAQs
                        </h1>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="leftFaqs">
                                    <mat-accordion>
                                        <mat-expansion-panel>
                                            <mat-expansion-panel-header>
                                                What form of educational philosophy does Kidzee follow?
                                            </mat-expansion-panel-header>
                                            <p class="mt-2 text-center">Kidzee Pre-school follows a child-centric
                                                educational philosophy that focuses on holistic development. Our
                                                approach combines play-based learning, creativity, and a nurturing
                                                environment to foster a love for learning.</p>
                                        </mat-expansion-panel>
                                        <mat-expansion-panel>
                                            <mat-expansion-panel-header>
                                                What sets Kidzee's curriculum apart from other pre-schools?
                                            </mat-expansion-panel-header>
                                            <p class="mt-2 text-center">Kidzee's curriculum is designed to provide a
                                                well-rounded education, emphasising creativity, critical thinking, and
                                                emotional intelligence. It's tailored to each age group and encourages
                                                experiential learning.</p>
                                        </mat-expansion-panel>
                                        <mat-expansion-panel>
                                            <mat-expansion-panel-header>
                                                Can a parent tour a Kidzee facility before enrolling their child?
                                            </mat-expansion-panel-header>
                                            <p class="mt-2 text-center">Yes, Kidzee encourages parents to visit our
                                                facilities to get a first-hand look at our nurturing environment. Please
                                                contact your local Kidzee centre to schedule a tour.</p>
                                        </mat-expansion-panel>

                                        <mat-expansion-panel>
                                            <mat-expansion-panel-header>
                                                What is the age requirement for admission at Kidzee?
                                            </mat-expansion-panel-header>
                                            <span>
                                                <p class="mt-2 mb-0 text-center">Playgroup: 1.5 - 2.5 Years</p>
                                                <p class="m-0 text-center">Nursery: 2.6 - 3.5 Years</p>
                                                <p class="m-0 text-center">Jr. KG: 3.6 - 4.5 Years</p>
                                                <p class="m-0 text-center">Sr. KG: 4.6 - 5.5 Years</p>
                                                <p class="m-0 text-center">This is the broad recommended age group. The
                                                    regional (state-wise) age criteria is applicable.</p>
                                            </span>
                                        </mat-expansion-panel>

                                        <mat-expansion-panel>
                                            <mat-expansion-panel-header>
                                                Which board does Kidzee follow?
                                            </mat-expansion-panel-header>
                                            <p class="mt-2 text-center">Kidzee focuses on what’s right for the child
                                                (WRFC) and is aligned with the National Education Policy (NEP) 2020 and
                                                the National Curriculum Framework (NCF) 2022. This approach prepares
                                                children for various boards, including State Board, CBSE, and ICSE.</p>
                                        </mat-expansion-panel>
                                    </mat-accordion>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/full_home.png" class="fullhome_img_content" alt="">
            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/more_fish.png" class="fish_img" alt="">

            <div class="mobileListDiv">
                <div class="faq_content">
                    <div class="title text-center">
                        FAQs
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="leftFaqs">
                                <mat-accordion>
                                    <mat-expansion-panel>
                                        <mat-expansion-panel-header>
                                            What form of educational philosophy does Kidzee follow?
                                        </mat-expansion-panel-header>
                                        <p class="mt-2 text-center">Kidzee Pre-school follows a child-centric
                                            educational philosophy that focuses on holistic development. Our approach
                                            combines play-based learning, creativity, and a nurturing environment to
                                            foster a love for learning.</p>
                                    </mat-expansion-panel>
                                    <mat-expansion-panel>
                                        <mat-expansion-panel-header>
                                            What sets Kidzee's curriculum apart from other pre-schools?
                                        </mat-expansion-panel-header>
                                        <p class="mt-2 text-center">Kidzee's curriculum is designed to provide a
                                            well-rounded education, emphasising creativity, critical thinking, and
                                            emotional intelligence. It's tailored to each age group and encourages
                                            experiential learning.</p>
                                    </mat-expansion-panel>
                                    <mat-expansion-panel>
                                        <mat-expansion-panel-header>
                                            Can a parent tour a Kidzee facility before enrolling their child?
                                        </mat-expansion-panel-header>
                                        <p class="mt-2 text-center">Yes, Kidzee encourages parents to visit our
                                            facilities to get a first-hand look at our nurturing environment. Please
                                            contact your local Kidzee centre to schedule a tour.</p>
                                    </mat-expansion-panel>

                                    <mat-expansion-panel>
                                        <mat-expansion-panel-header>
                                            What is the age requirement for admission at Kidzee?
                                        </mat-expansion-panel-header>
                                        <p class="mt-2 text-center mb-0">Playgroup: 1.5 - 2.5 Years</p>
                                        <p class="m-0 text-center"> Nursery: 2.6 - 3.5 Years</p>
                                        <p class="m-0 text-center"> Jr. KG: 3.6 - 4.5 Years</p>
                                        <p class="m-0 text-center">Sr. KG: 4.6 - 5.5 Years</p>
                                        <p class="m-0 text-center">This is the broad recommended age group. The regional
                                            (state-wise) age criteria is applicable.</p>
                                    </mat-expansion-panel>

                                    <mat-expansion-panel>
                                        <mat-expansion-panel-header>
                                            Which board does Kidzee follow?
                                        </mat-expansion-panel-header>
                                        <span>Kidzee focuses on what’s right for the child (WRFC) and is aligned with
                                            the National Education Policy (NEP) 2020 and the National Curriculum
                                            Framework (NCF) 2022. This approach prepares children for various boards,
                                            including State Board, CBSE, and ICSE.</span>
                                    </mat-expansion-panel>
                                </mat-accordion>
                            </div>
                        </div>
                        <!-- <div class="col-md-6">
                            <div class="rightFaqs">
                                <mat-accordion>
                                    <mat-expansion-panel *ngFor="let dt of faqdata;let odd = odd;let i=index">
                                            <mat-expansion-panel-header  *ngIf="odd ==true">
                                                {{dt.Title}}
                                            </mat-expansion-panel-header>
                                            <span [innerHTML]="dt.Short"></span>
                                    </mat-expansion-panel>
                                </mat-accordion>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="testimonial_content" >
            <app-testimonial></app-testimonial>
        </div> -->
    </div>

    <div class="testimonial_content" id="testimonials_div">

        <h1 class="title text-center">
            Testimonials<br>
            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/bottom_img.png" class="bottom_img_content_testimonial" alt="">
        </h1>
        <div class="testimonial">
            <div id="carouselExampleControlsT" class="carousel slide" data-bs-ride="carousel">
                <div class="carousel-inner">
                    <div class="carousel-item active">
                        <div class="testimonial_para">
                            <h5 class="text-center">Antara Chatterjee</h5>
                            <p class="text-center">My daughter was a student of Kidzee for 3 years. I would like to thank the Kidzee family who have put in a lot of efforts to groom her personality.</p>
                        </div>
                    </div>
                    <div class="carousel-item">
                        <div class="testimonial_para">
                            <h5 class="text-center">Namrata Shastri</h5>
                            <p class="text-center">Our heartfelt gratitude to Kidzee Hyderabad for providing our kids a home away home to facilitate their growth and development.</p>
                        </div>
                    </div>

                    <div class="carousel-item">
                        <div class="testimonial_para">
                            <h5 class="text-center">Nityam R.</h5>
                            <p class="text-center">Kidzee has a very supportive team of teachers and counselors. My son has been taken care of so well by the teachers. Their curriculum is one of the best I've come across.</p>
                        </div>
                    </div>

                    <div class="carousel-item">
                        <div class="testimonial_para">

                            <h5 class="text-center">Parents of Bhushn Krishna.</h5>
                            <p class="text-center">Dear Kidzee team, and faculties, we thank you for lighting my son's educational career bearing his naughtiness patiently with more tolerance. Because of all of your efforts and continued teaching, he has become mature and shows interest in reading and writing his home works as well as in playing. We have no doubt that his coming academic year also will be shining and confident that he is in the best hands.</p>
                        </div>
                    </div>
                    <div class="carousel-item">
                        <div class="testimonial_para">

                            <h5 class="text-center">Parents of Dharshavardini (Sr.K.G)</h5>
                            <p class="text-center">Thanks to all of you for the support and love for Dharsha. She has been directly admitted to Sr. K.G (no prior schooling). In a short period of time, her reserved nature changed a lot she started to mingle with others easily, and she learned very well and it was not possible without your guidance. You are the best among prior schooling kids we have ever known!</p>
                        </div>
                    </div>
                </div>
                <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControlsT"
                    data-bs-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                </button>
                <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControlsT"
                    data-bs-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Next</span>
                </button>
            </div>

        </div>

        <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/bag_img.png" class="bag_img_content" alt="">
        <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/bird.png" class="bird_img_content" alt="">
    </div>

</section>
<div class="footer_contenr">
    <footer class="desktopResponsive">
        <div class="footerContent">
            <div class="row py-5">
                <div class="col-md-4">
                    <div class="logo_box d-flex">
                        <div class="kidzeeLogo">
                            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/Kidzee_Logo.svg" width="90%" alt="">
                        </div>
                        <div class="zeeLogo">
                            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/zee_footer_logo.png" width="90%" alt="">
                        </div>
                    </div>
                </div>
                <div class="col-md-4 d-flex justify-content-center">
                    <div class="footer_content">
                        <p class="text-white">For Admissions Enquiry,</p>
                        <a href="tel:9320063100"><p class="text-white">Call +91 93200 63100</p></a>
                        <p class="text-white">Monday to Friday - 10 a.m. to 6 p.m.</p>
                    </div>
                </div>
                <div class="col-md-4 d-flex justify-content-center align-items-center">
                    <div class="fb_insta_icon_content">

                        <a href="https://www.facebook.com/KidzeeIndia" target="_blank"> <i
                                class="fa fa-facebook media_icon"></i></a>
                        <a href="https://www.instagram.com/kidzeeindia/" target="_blank">
                            <i class="fa fa-instagram media_icon"></i>
                        </a>
                        <a href="https://www.instagram.com/kidzeeindia/" target="_blank">
                            <i class="fa fa-youtube-play media_icon"></i>
                        </a>
                    </div>
                </div>
            </div>

        </div>

        <div class="btn_header" id="footer_btn">
            <div class="row">
                <div class="col-md-12">
                    <div class="text-white text-center footerTextEmailId">
                        Copyright © 2025 Zee Learn Ltd. | T&C | Privacy Policy | Disclaimer
                    </div>
                </div>
            </div>
            <!-- <div class="btn_content">
                <div class="fb_insta_icon_content">
    
                 <a href="https://www.facebook.com/KidzeeIndia" target="_blank"> <i class="fa fa-facebook media_icon"></i></a>
                 <a href="https://www.instagram.com/kidzeeindia/" target="_blank">
                    <i class="fa fa-instagram media_icon"></i>
                 
                </a>
                </div>
                <div class="btn_div d-flex">
                    <div class="d-flex justify-content-center align-items-center  px-2">
                        <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/admission_icon.png" width="25px" height="30px" alt="">
                <button class="white_btn brder_right" routerLink="/admissions">Admission Enquiry</button>
            </div>
            <div class="d-flex justify-content-center align-items-center px-2">
                <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/start_icon.png" width="25px" height="30px" alt="">
                <button class="white_btn" routerLink="/partner-with-kidzee">Start a Franchise</button>
            </div>
            </div>
            </div> -->

        </div>
        <a href="#" class="scrollToTop" id="scroll_Top_btn">
            <button class="btn scroll_btn"><i class="fa fa-chevron-up"></i></button></a>
    </footer>

    <footer class="mobileResponsive">
        <div class="footerContent">
            <div class="row pb-5">
                <div class="col-md-4">
                    <div class="logo_box">
                        <div class="kidzeeLogo d-flex justify-content-center">
                            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/Kidzee_Logo.svg" width="65%" alt="">
                        </div>
                        <div class="zeeLogo d-flex justify-content-center">
                            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/zee_footer_logo.png" width="65%" alt="">
                        </div>
                    </div>
                </div>
                <div class="col-md-4 d-flex justify-content-center mt-4">
                    <div class="footer_content">
                        <p class="text-white">For Admissions Enquiry,</p>
                        <a href="tel:9320063100"><p class="text-white">Call +91 93200 63100</p></a>
                        <p class="text-white">Monday to Friday - 10 a.m. to 6 p.m.</p>
                    </div>
                </div>
                <div class="col-md-4 d-flex justify-content-center align-items-center">
                    <div class="fb_insta_icon_content">

                        <a href="https://www.facebook.com/KidzeeIndia" target="_blank"> <i
                                class="fa fa-facebook media_icon"></i></a>
                        <a href="https://www.instagram.com/kidzeeindia/" target="_blank">
                            <i class="fa fa-instagram media_icon"></i>
                        </a>
                        <a href="https://www.instagram.com/kidzeeindia/" target="_blank">
                            <i class="fa fa-youtube-play media_icon"></i>
                        </a>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="text-white text-center footerTextEmailId">
                        Copyright © Zee Learn Ltd. All rights reserved.
                    </div>
                </div>
                <!-- <div class="col-dm-12">
                    <div class="fb_insta_icon_content">
                       
                        <div class="btn_div d-flex">
                            <div class="d-flex justify-content-center align-items-center  px-2">
                                <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/admission_icon.png" width="25px" height="30px" alt="">
                        <button class="white_btn brder_right" routerLink="/admissions">Admission Enquiry</button>
                    </div>
                    <div class="d-flex justify-content-center align-items-center px-2">
                        <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/start_icon.png" width="25px" height="30px" alt="">
                        <button class="white_btn" routerLink="/partner-with-kidzee">Start a Franchise</button>
                    </div>
                    </div>
                    </div>
                </div> -->
            </div>
        </div>

        <a href="#" class="scrollToTop" id="scroll_Top_btn">
            <button class="btn scroll_btn"><i class="fa fa-chevron-up"></i></button></a>
    </footer>

</div>